import { ServicesCategoriesActionsTypes } from "../types/ServicesCategories.reducer.types";

export function createRequest(values, { setSubmitting }, closePanel, isAdmin?) {
  return {
    type: ServicesCategoriesActionsTypes.CREATE_REQUEST,
    payload: { values, setSubmitting, closePanel, isAdmin }
  };
}

export function createSuccess(message) {
  return {
    type: ServicesCategoriesActionsTypes.CREATE_SUCCESS,
    payload: { message }
  };
}

export function createFailure(message) {
  return {
    type: ServicesCategoriesActionsTypes.CREATE_FAIL,
    payload: { message }
  };
}

export function editRequest(values, { setSubmitting }, closePanel, isAdmin?) {
  return {
    type: ServicesCategoriesActionsTypes.EDIT_REQUEST,
    payload: { values, setSubmitting, closePanel, isAdmin }
  };
}

export function editSuccess(message) {
  return {
    type: ServicesCategoriesActionsTypes.EDIT_SUCCESS,
    payload: { message }
  };
}

export function editFailure(message) {
  return {
    type: ServicesCategoriesActionsTypes.EDIT_FAIL,
    payload: { message }
  };
}

export function listRequest(filter?, isAdmin?) {
  return {
    type: ServicesCategoriesActionsTypes.LIST_REQUEST,
    payload: { filter, isAdmin }
  };
}

export function listSuccess({ list }) {
  return {
    type: ServicesCategoriesActionsTypes.LIST_SUCCESS,
    payload: { list }
  };
}

export function listFailure() {
  return {
    type: ServicesCategoriesActionsTypes.LIST_FAIL
  };
}

export function dismissMessage() {
  return {
    type: ServicesCategoriesActionsTypes.DISMISS_MESSAGE
  };
}
